export function formatPaxTriggerLabel(numberOfAdults: number, agesOfChildren: number[]): string {
    const adultText = numberOfAdults === 1 ? '1 voksen' : `${numberOfAdults} voksne`;
    const childrenText = agesOfChildren.length > 0 ? `, ${agesOfChildren.length} barn` : '';
    return `${adultText}${childrenText}`;
}
